var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('favicon-picker',{attrs:{"upload-url":_vm.uploadUrl,"favicon-url":_vm.faviconUrl,"favicon":_vm.favicon,"disabled":_vm.project.isArchived},on:{"input":_vm.faviconChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }